import { createElement } from 'react';
import styled, { ThemeProvider } from 'styled-components';

var PHONE_FRAME_WIDTH = 352;
var PHONE_FRAME_HEIGHT = 712;
var PHONE_FRAME_CONTENT_WIDTH = 320;

var defaultViberBusinessLabels = {
    businessAccount: 'Business Account',
    about: 'About',
    address: 'Address',
    phoneNumber: 'Phone Number',
    shareLink: 'Share link',
    shareLinkDescription: 'Anyone with this link can subscribe to the business messages',
    receiveMessages: 'Receive messages',
    receiveMessagesHelpText: 'You are receiving messages',
    muteMessages: 'Mute messages',
    muteMessagesHelpText: 'You will not receive any notifications',
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function SvgInsertPhotoIcon(props) {
    return (createElement("svg", __assign({ width: 60, height: 60, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        createElement("defs", null,
            createElement("path", { d: "M63.333 16.667v46.666H16.667V16.667h46.666zm0-6.667H16.667C13 10 10 13 10 16.667v46.666C10 67 13 70 16.667 70h46.666C67 70 70 67 70 63.333V16.667C70 13 67 10 63.333 10zm-16.2 29.533l-10 12.9L30 43.8 20 56.667h40L47.133 39.533z", id: "insert-photo-icon_svg__a" })),
        createElement("g", { transform: "translate(-10 -10)", fill: "none", fillRule: "evenodd" },
            createElement("mask", { id: "insert-photo-icon_svg__b", fill: "#fff" },
                createElement("use", { xlinkHref: "#insert-photo-icon_svg__a" })),
            createElement("g", { mask: "url(#insert-photo-icon_svg__b)", fill: "#FFF" },
                createElement("path", { d: "M0 0h80v80H0z" })))));
}

function SvgPhoneFrame(props) {
    return (createElement("svg", __assign({ width: 352, height: 712, xmlns: "http://www.w3.org/2000/svg" }, props),
        createElement("g", { fill: "none", fillRule: "evenodd" },
            createElement("path", { d: "M41.022 0h269.956c14.264 0 19.437 1.485 24.652 4.274 5.214 2.789 9.307 6.882 12.096 12.096C350.515 21.585 352 26.758 352 41.022v629.956c0 14.264-1.485 19.437-4.274 24.652-2.789 5.214-6.882 9.307-12.096 12.096-5.215 2.789-10.388 4.274-24.652 4.274H41.022c-14.264 0-19.437-1.485-24.652-4.274-5.214-2.789-9.307-6.882-12.096-12.096C1.485 690.415 0 685.242 0 670.978V41.022C0 26.758 1.485 21.585 4.274 16.37c2.789-5.214 6.882-9.307 12.096-12.096C21.585 1.485 26.758 0 41.022 0z", fill: "#CFCFCF" }),
            createElement("path", { d: "M41.639 15.5c-9.057 0-12.334.96-15.643 2.73a18.666 18.666 0 00-7.766 7.766c-1.77 3.309-2.73 6.586-2.73 15.643V670.36c0 9.057.96 12.334 2.73 15.643a18.666 18.666 0 007.766 7.766c3.309 1.77 6.586 2.73 15.643 2.73H310.36c9.057 0 12.334-.96 15.643-2.73a18.666 18.666 0 007.766-7.766c1.77-3.309 2.73-6.586 2.73-15.643V41.64c0-9.057-.96-12.334-2.73-15.643a18.666 18.666 0 00-7.766-7.766c-3.309-1.77-6.586-2.73-15.643-2.73H41.64z", stroke: "#979797", fill: "#D8D8D8" }))));
}

function SvgShareColoredIcon(props) {
    return (createElement("svg", __assign({ width: 40, height: 40, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        createElement("defs", null,
            createElement("path", { d: "M11.512 17.562l-.889-.127s-.592-.127-.888-.254a.556.556 0 00-.508.127l-.212.211c-1.227 1.227-3.215 1.354-4.484.254-1.439-1.227-1.481-3.427-.17-4.738l3.216-3.216c.423-.423.93-.677 1.438-.846a3.328 3.328 0 012.031.127c.38.17.762.38 1.1.72.17.168.296.338.423.55.17.295.55.338.762.084l1.184-1.185c.17-.169.17-.423.043-.634-.17-.254-.381-.466-.593-.677-.296-.296-.634-.593-1.015-.804a5.403 5.403 0 00-1.988-.762 6.049 6.049 0 00-3.935.593c-.465.253-.93.592-1.312.973l-3.088 3.088c-2.242 2.242-2.412 5.88-.254 8.166 2.242 2.453 6.05 2.496 8.377.169l1.058-1.058c.296-.211.084-.72-.296-.761zm7.784-15.189C16.97.215 13.331.385 11.131 2.627l-.973.93c-.296.297-.085.805.296.847a8.77 8.77 0 011.777.338c.169.043.38 0 .507-.127l.212-.211c1.227-1.227 3.215-1.354 4.485-.254 1.438 1.227 1.48 3.427.169 4.738l-3.216 3.216c-.423.423-.93.677-1.438.846a3.328 3.328 0 01-2.03-.127c-.382-.17-.762-.38-1.1-.72a2.716 2.716 0 01-.424-.55c-.17-.295-.55-.338-.761-.084L7.45 12.654c-.17.169-.17.423-.042.634.169.254.38.466.592.677.296.297.677.593 1.015.804.593.381 1.27.635 1.947.762a6.049 6.049 0 003.934-.593c.466-.253.93-.592 1.312-.973l3.215-3.215c2.37-2.327 2.285-6.135-.127-8.377z", id: "share-colored-icon_svg__a" })),
        createElement("g", { fill: "none", fillRule: "evenodd" },
            createElement("rect", { fill: "#5890EB", width: 40, height: 40, rx: 16 }),
            createElement("use", { fill: "#FFF", xlinkHref: "#share-colored-icon_svg__a", transform: "translate(9 9)" }))));
}

function SvgSwitch(props) {
    return (createElement("svg", __assign({ width: 38, height: 26, xmlns: "http://www.w3.org/2000/svg" }, props),
        createElement("g", { fill: "none", fillRule: "evenodd" },
            createElement("rect", { fill: "#D3D4D6", y: 5, width: 38, height: 16, rx: 8 }),
            createElement("circle", { fill: "#7360F2", cx: 25, cy: 13, r: 13 }))));
}

function SvgWebsiteIcon(props) {
    return (createElement("svg", __assign({ width: 40, height: 40, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        createElement("defs", null,
            createElement("path", { d: "M18.848 10.385h-1.923v8.461c0 .23-.154.385-.385.385h-3.846c-.23 0-.385-.154-.385-.385v-6.538H7.694v6.538c0 .23-.154.385-.385.385H3.463c-.23 0-.385-.154-.385-.385v-8.461H1.155c-.153 0-.307-.077-.346-.231C.732 10 .771 9.846.886 9.73L9.732.885c.154-.154.423-.154.539 0l8.846 8.846c.115.115.115.269.077.423-.039.154-.192.23-.346.23z", id: "website-icon_svg__a" })),
        createElement("g", { fill: "none", fillRule: "evenodd" },
            createElement("rect", { fill: "#54D37B", width: 40, height: 40, rx: 16 }),
            createElement("use", { fill: "#FFF", xlinkHref: "#website-icon_svg__a", transform: "translate(10 9)" }))));
}

var Wrapper = styled.div({
    position: 'relative',
    width: PHONE_FRAME_WIDTH,
    margin: '0 auto',
});
var Content = styled.div({
    height: '95.5%',
    overflow: 'hidden',
    position: 'absolute',
    top: '2.3%',
    left: '4.4%',
    borderRadius: 20,
});
var ContentInner = styled.div({
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: PHONE_FRAME_CONTENT_WIDTH,
});
var PhoneFrame = function (_a) {
    var children = _a.children;
    return (createElement(Wrapper, null,
        createElement(SvgPhoneFrame, null),
        createElement(Content, null,
            createElement(ContentInner, null, children))));
};

var getDisabledStyle = function (disabled) { return ({
    opacity: disabled ? 0.2 : undefined,
}); };
var SectionPanel = styled.div(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing.medium,
        marginBottom: theme.spacing.small,
        backgroundColor: theme.colors.section,
        boxShadow: "0px 2px " + theme.colors.shadow,
        display: 'flex',
        alignItems: 'center',
    });
});
var SectionIcon = styled.span(function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return (__assign({ marginRight: theme.spacing.medium, display: 'inline-flex' }, getDisabledStyle(disabled !== null && disabled !== void 0 ? disabled : false)));
});
var SectionContent = styled.div(function (_a) {
    var disabled = _a.disabled;
    return (__assign({ width: '100%' }, getDisabledStyle(disabled !== null && disabled !== void 0 ? disabled : false)));
});
var Section = function (_a) {
    var children = _a.children, icon = _a.icon, disabled = _a.disabled;
    return (createElement(SectionPanel, null,
        icon && createElement(SectionIcon, { disabled: disabled }, icon),
        createElement(SectionContent, { disabled: disabled }, children)));
};

var Header = styled.h5(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.elementDefaults.text), { fontWeight: theme.text.weight.bold, fontSize: '14px', color: theme.colors.text, marginBottom: theme.spacing.tiny }));
});
var SectionBoldHeader = function (_a) {
    var text = _a.text;
    return createElement(Header, null, text);
};

var Link = styled.a(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.elementDefaults.text), { fontWeight: theme.text.weight.normal, fontSize: '13px', lineHeight: '19px', color: theme.colors.text, pointerEvents: 'none', textDecoration: 'underline' }));
});
var SectionLink = function (_a) {
    var href = _a.href;
    return createElement(Link, { href: href }, href);
};

var Paragraph = styled.p(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.elementDefaults.text), { fontWeight: theme.text.weight.normal, fontSize: '13px', lineHeight: '19px', color: theme.colors.text }));
});
var SectionParagraph = function (_a) {
    var text = _a.text;
    return createElement(Paragraph, null, text);
};

var Panel = styled.div(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'stretch',
        alignItems: 'center',
        ':not(:last-child)': {
            marginBottom: theme.spacing.large,
        },
    });
});
var SwitchPanel = styled.div({
    marginLeft: 'auto',
});
var SectionToggleButton = function (_a) {
    var title = _a.title, helpText = _a.helpText;
    return (createElement(Panel, null,
        createElement("div", null,
            createElement(SectionBoldHeader, { text: title }),
            createElement(SectionParagraph, { text: helpText })),
        createElement(SwitchPanel, null,
            createElement(SvgSwitch, null))));
};

var Header$1 = styled.h5(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.elementDefaults.text), { fontWeight: theme.text.weight.bold, fontSize: '11px', textTransform: 'uppercase', color: theme.colors.header, marginBottom: theme.spacing.tiny }));
});
var SectionUppercaseHeader = function (_a) {
    var text = _a.text;
    return createElement(Header$1, null, text);
};

var Background = styled.div(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.colors.bannerBackground,
        position: 'relative',
        height: '270px',
    });
});
var BackgroundOverlay = styled.div({
    background: 'linear-gradient(0deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.2) 100%)',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
});
var ImageContent = styled.div({
    display: 'flex',
    'justify-content': 'center',
    width: 'inherit',
    overflow: 'hidden',
});
var Image = styled.img({
    position: 'absolute',
    top: 0,
    height: '100%',
});
var TextPanel = styled.div(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.bannerText,
        position: 'absolute',
        left: theme.spacing.medium,
        bottom: theme.spacing.medium,
    });
});
var NameParagraph = styled.p(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.elementDefaults.text), { marginBottom: '7px', fontWeight: theme.text.weight.thin, fontSize: '20px' }));
});
var SenderTypeParagraph = styled.p(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.elementDefaults.text), { margin: 0, padding: 0, fontWeight: theme.text.weight.normal, fontSize: '11px' }));
});
var Banner = function (_a) {
    var businessAccountLabel = _a.businessAccountLabel, name = _a.name, photoUrl = _a.photoUrl;
    return (createElement(Background, null,
        createElement(ImageContent, null,
            createElement(Image, { src: photoUrl })),
        createElement(BackgroundOverlay, null, !photoUrl && createElement(SvgInsertPhotoIcon, null)),
        createElement(TextPanel, null,
            createElement(NameParagraph, null, name),
            createElement(SenderTypeParagraph, null, businessAccountLabel))));
};

var theme = {
    colors: {
        header: '#7C7C7C',
        text: '#313233',
        bannerText: 'white',
        bannerBackground: '#7360F2',
        shadow: '#EEEFF0',
        section: 'white',
    },
    spacing: {
        tiny: '4px',
        small: '8px',
        medium: '16px',
        large: '24px',
    },
    elementDefaults: {
        text: {
            margin: 0,
            padding: 0,
        },
    },
    text: {
        weight: {
            bold: 500,
            normal: 400,
            thin: 300,
        },
    },
};

var Panel$1 = styled.div({
    backgroundColor: '#CFCFCF',
    fontFamily: 'AtlasGroteskWeb',
});
var ViberBusinessPreview = function (_a) {
    var _b = _a.input, name = _b.name, about = _b.about, address = _b.address, phoneNumber = _b.phoneNumber, website = _b.website, photoUrl = _b.photoUrl, labelsOverride = _a.labelsOverride;
    var labels = __assign(__assign({}, defaultViberBusinessLabels), labelsOverride);
    return (createElement(ThemeProvider, { theme: theme },
        createElement(Panel$1, null,
            createElement(Banner, { businessAccountLabel: labels.businessAccount, name: name !== null && name !== void 0 ? name : undefined, photoUrl: photoUrl !== null && photoUrl !== void 0 ? photoUrl : undefined }),
            createElement(Section, null,
                createElement(SectionUppercaseHeader, { text: labels.about }),
                createElement(SectionParagraph, { text: about !== null && about !== void 0 ? about : '' })),
            createElement(Section, null,
                createElement(SectionUppercaseHeader, { text: labels.address }),
                createElement(SectionParagraph, { text: address !== null && address !== void 0 ? address : '' })),
            createElement(Section, null,
                createElement(SectionUppercaseHeader, { text: labels.phoneNumber }),
                createElement(SectionParagraph, { text: phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : '' })),
            createElement(Section, { icon: createElement(SvgWebsiteIcon, null) },
                createElement(SectionLink, { href: website !== null && website !== void 0 ? website : 'http://website' })),
            createElement(Section, { icon: createElement(SvgShareColoredIcon, null), disabled: true },
                createElement(SectionBoldHeader, { text: labels.shareLink }),
                createElement(SectionParagraph, { text: labels.shareLinkDescription })),
            createElement(Section, { disabled: true },
                createElement(SectionToggleButton, { title: labels.receiveMessages, helpText: labels.receiveMessagesHelpText }),
                createElement(SectionToggleButton, { title: labels.muteMessages, helpText: labels.muteMessagesHelpText })))));
};

export { PHONE_FRAME_CONTENT_WIDTH, PHONE_FRAME_HEIGHT, PHONE_FRAME_WIDTH, PhoneFrame, ViberBusinessPreview, defaultViberBusinessLabels };
//# sourceMappingURL=index.js.map
